<dx-validation-group #validatorRetrieveUserName>
  <div class="retrieve-form-wrapper" *ngIf="!isEmailSent">
    <!-- Error Message -->
    <div class="error-message-container" *ngIf="showErrorMessage">
      <p class="error-message">{{ errorMessage }}</p>
    </div>

    <!-- Email Input -->
    <div class="retrieve-input-wrapper">
      <label for="txtEmail" class="input-label">
        Email
        <span class="required-asterisk">*</span>
      </label>
      <dx-text-box
        id="txtEmail"
        placeholder="Email"
        [(value)]="email"
        class="email-input"
        (onEnterKey)="btnRetrieveUserName(null)"
      >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="Email is required"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="email"
            message="Email is invalid"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <!-- reCAPTCHA -->
    <div class="recaptcha-container">
      <re-captcha
        #reCaptcha
        [siteKey]="recaptchaSiteKey"
        errorMode="handled"
        (resolved)="onRecaptchaResolved($event)"
        (errored)="onRecaptchaErrored()"
      ></re-captcha>
      <p *ngIf="recaptchaErrorMessage" class="recaptcha-error-message">
        {{ recaptchaErrorMessage }}
      </p>
    </div>

    <!-- Back to Login Button -->
    <div class="back-to-login-container">
      <dx-button
        class="back-to-login-button"
        type="default"
        (onClick)="btnBackToLogin($event)"
      >
        <div class="back-button-content">
          <span>Back to Sign In</span>
        </div>
      </dx-button>
    </div>

    <!-- Retrieve Button -->
    <div class="retrieve-button-wrapper">
      <dx-button
        text="Submit"
        class="retrieve-button"
        type="default"
        (onClick)="btnRetrieveUserName($event)"
      ></dx-button>
    </div>

    <div class="signup-container">
      <span>Already have an account?</span>
      <a href="javascript:void(0)" (click)="btnBackToLogin($event)">Sign In</a>
    </div>
  </div>

  <!-- Success Message -->
  <div class="success-wrapper" *ngIf="isEmailSent">
    <div class="success-icon-container">
      <i class="fa-solid fa-circle-check success-icon"></i>
    </div>
    <div class="success-message-container">
      <p class="success-message">
        Your request has been successfully submitted!
        <br />
        <br />
        Please check your email for your account information.
      </p>
    </div>
    <div class="signup-container">
      <span>Already have an account?</span>
      <a
        href="javascript:void(0)"
        (click)="btnBackToLogin($event)"
        class="sign-in-link"
      >
        Sign In
      </a>
    </div>
  </div>
</dx-validation-group>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
